import { useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import it from 'date-fns/locale/it';
import secondsToHms from "../../utility/SecondToHms";
import { useTranslation } from "react-i18next";

function DateAndTimeRangePicker({
    extDateRange = null,
    onDateTimePicked = () => { },
    minDaysNotice = 0
}) {

    const [t, i18n] = useTranslation(["global"])
    const [date, setDateTime] = useState(new Date().getDateWithoutTime());
    const [startTime, setStartTime] = useState(new Date(new Date().setHours(new Date().getHours() + 1, 0, 0)));
    const [endTime, setEndTime] = useState(new Date(new Date(startTime).setHours(startTime.getHours() + 1)));
    const [duration, setDuration] = useState(null)


    useEffect(() => {

        // console.log("Date" + date)
        console.log("startTime" + startTime)
        console.log("endTime" + endTime)

        if (startTime != null && endTime != null) {
            const startDateTime = new Date(date).setHours(startTime.getHours(), startTime.getMinutes())
            const endDateTime = new Date(date).setHours(endTime.getHours(), endTime.getMinutes())

            const delta = (endTime.getTime() - startTime.getTime()) / 1000
            if (delta < 0) {
                setEndTime(startTime)
            }
            setDuration((endTime.getTime() - startTime.getTime()) / 1000)
            console.log("duration:" + duration)
            console.log("Range: " + new Date(startDateTime) + new Date(endDateTime))

            onDateTimePicked([new Date(startDateTime), new Date(endDateTime)])

        }




    }, [date, startTime, endTime])

    // Calcola la data minima basata su minDaysNotice
    const minSelectableDate = new Date();
    minSelectableDate.setDate(minSelectableDate.getDate() + minDaysNotice);

    return (

        <>
            {console.log("render")}

            <DatePicker
                className="p-2"
                //showIcon
                dateFormat="dd/MM/yyyy"
                selected={date}
                onChange={(update) => {
                    setDateTime(update);
                }}
                locale={it}
                minDate={minSelectableDate} // Imposta la data minima
            /><br /><br />

            <div className="container text-center">

                <div className="row">
                    <div className="col-6 col-sm-3">{t("particles.from_time")}</div>
                    <div className="col-6 col-sm-3"> <DatePicker
                        selected={startTime}
                        onChange={(date) => setStartTime(date)}
                        locale={it}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        timeCaption="Time"
                        dateFormat="H:mm"
                    /></div>


                    <div className="w-100 p-2">{secondsToHms(duration)}</div>

                    <div className="col-6 col-sm-3">{t("particles.to_time")}</div>
                    <div className="col-6 col-sm-3"> <DatePicker
                        selected={endTime}
                        onChange={(date) => setEndTime(date)}
                        locale={it}
                        showTimeSelect
                        showTimeSelectOnly
                        timeIntervals={30}
                        timeCaption="Time"
                        dateFormat="H:mm"
                    /></div>
                </div>
            </div >



        </>



    );
};

Date.prototype.getDateWithoutTime = function () {
    return new Date(this.toDateString());
}

export default DateAndTimeRangePicker